/**
 * Single source of truth for reading the auth token from localStorage (F-5.5).
 *
 * Historically the token was read two inconsistent ways across the app:
 *   - apiService used `getItem('token') || getItem('authToken')` (fallback), and
 *   - documentService / Message / useDocumentBlobUrl / workspaceService / usageService
 *     read only `getItem('token')`.
 * Login (`useAuth`) writes BOTH keys together, so in practice they agree — but the
 * split made every reader ad-hoc. This helper reads `'token'`, falling back to
 * `'authToken'`, so every call site behaves identically. Writes are unchanged
 * (still done in `useAuth`).
 *
 * @returns {string|null} the auth token, or null if neither key is set.
 */
export const getAuthToken = () =>
    localStorage.getItem('token') || localStorage.getItem('authToken');
